/**
 * @generated SignedSource<<a4b1585e6c11074221b2981601c0818f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeartPill_viewer$data = {
  readonly id: string;
  readonly " $fragmentType": "HeartPill_viewer";
};
export type HeartPill_viewer$key = {
  readonly " $data"?: HeartPill_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeartPill_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeartPill_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2a73cc0aea2ce96c9658c0c14ce40339";

export default node;
